import { emailTemplateProcessingApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const EMAIL_TEMPLATES_PROCESSING_TYPE = createNamedActions('emailTemplateProcessing', {
  GET_SPECIAL_LINKS: 'GET_SPECIAL_LINKS',
});

export const getEmailTemplateSpecialLinksAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await emailTemplateProcessingApi.getSpecialLinks();

  return dispatch({
    type: EMAIL_TEMPLATES_PROCESSING_TYPE.GET_SPECIAL_LINKS,
    payload: data,
  });
});
